import { addMinutes, startOfToday } from 'date-fns/esm'
import type { Hour } from '../typings'

export function buildTimeSlots(
  interval: 10 | 15 | 20 | 30 | 60 = 30,
  startHour: Hour = 1,
  endHour: Hour = 24,
) {
  const firstTime = 60 * startHour
  const lastTime = 60 * endHour
  const minutes: number[] = [firstTime]

  while (minutes[minutes.length - 1] < lastTime) {
    minutes.push(minutes[minutes.length - 1] + interval)
  }

  const dateSlots: Date[] = minutes.map((m) => addMinutes(startOfToday(), m))

  return dateSlots
}
